// extracted by mini-css-extract-plugin
export default {"homepage":"Homepage_homepage__2O0I8"};